

// import React, { useState, useEffect } from "react";
// import Sidebar from "../../Components/Sidebar";
// import TopNav from "../../Components/TopNav";
// import {
//   getProductServ,
//   updateProductServ,
//   deleteProductServ,
//   uploadExcelServ,
//   downloadProductExportServ,
//   downloadSampleProductFileServ,
//   bulkDeleteProductsServ,
// } from "../../services/product.services";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import moment from "moment";
// import NoRecordFound from "../../Components/NoRecordFound";
// import { useNavigate } from "react-router-dom";
// import { getCategoryServ } from "../../services/category.service";
// import { triggerFileDownload } from "../../utils/fileDownload";


// import { IMAGE_BASE_URL } from "../../utils/api_base_url_configration";

// /* ─── Scoped styles — same design language as OrderList ─── */
// const styles = `
//   @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=JetBrains+Mono:wght@500;600&display=swap');

//   .pl-root {
//     background: #f5f5f7;
//     min-height: 100%;
//     padding: 28px;
//     font-family: 'DM Sans', 'Segoe UI', sans-serif;
//   }

//   /* ── Stat grid ── */
//   .pl-stat-grid {
//     display: grid;
//     grid-template-columns: repeat(3, 1fr);
//     gap: 14px;
//     margin-bottom: 22px;
//   }
//   @media (max-width: 900px)  { .pl-stat-grid { grid-template-columns: repeat(2,1fr); } }
//   @media (max-width: 560px)  { .pl-stat-grid { grid-template-columns: 1fr; } }

//   .pl-stat-card {
//     background: #fff;
//     border-radius: 14px;
//     padding: 18px 20px;
//     border: 1px solid #f0eded;
//     display: flex;
//     align-items: center;
//     gap: 16px;
//   }
//   .pl-stat-icon {
//     width: 46px; height: 46px;
//     border-radius: 12px;
//     background: #fdf2f1;
//     display: flex; align-items: center; justify-content: center;
//     font-size: 22px;
//     color: #a60808;
//     flex-shrink: 0;
//   }
//   .pl-stat-val {
//     font-size: 26px;
//     font-weight: 700;
//     color: #1c0a0a;
//     line-height: 1;
//     font-family: 'JetBrains Mono', monospace;
//   }
//   .pl-stat-lbl {
//     font-size: 14px;
//     color: #828282;
//     margin-top: 5px;
//     font-weight: 500;
//   }

//   /* ── Toolbar ── */
//   .pl-toolbar {
//     background: #fff;
//     border-radius: 14px;
//     padding: 18px 22px;
//     border: 1px solid #f0eded;
//     display: flex;
//     align-items: center;
//     flex-wrap: wrap;
//     gap: 12px;
//     margin-bottom: 16px;
//   }
//   .pl-toolbar-title {
//     font-size: 20px;
//     font-weight: 700;
//     color: #1c0a0a;
//     margin-right: auto;
//   }

//   .pl-input {
//     height: 40px;
//     border-radius: 10px;
//     border: 1px solid #f0eded;
//     padding: 0 14px;
//     font-size: 14px;
//     color: #444;
//     background: #f9f9f9;
//     outline: none;
//     min-width: 170px;
//     font-family: 'DM Sans', sans-serif;
//   }
//   .pl-input:focus { border-color: #f0c0b8; }
//   .pl-input::placeholder { color: #bbb; }

//   .pl-select {
//     height: 40px;
//     border-radius: 10px;
//     border: 1px solid #f0eded;
//     padding: 0 14px;
//     font-size: 14px;
//     color: #555;
//     background: #f9f9f9;
//     outline: none;
//     cursor: pointer;
//     font-family: 'DM Sans', sans-serif;
//   }
//   .pl-select:focus { border-color: #f0c0b8; }

//   /* buttons */
//   .pl-btn {
//     height: 40px;
//     padding: 0 18px;
//     border-radius: 10px;
//     border: none;
//     font-size: 14px;
//     font-weight: 600;
//     cursor: pointer;
//     display: inline-flex; align-items: center; gap: 7px;
//     white-space: nowrap;
//     transition: all 0.18s;
//     font-family: 'DM Sans', sans-serif;
//   }
//   .pl-btn-red    { background: #a60808; color: #fff; }
//   .pl-btn-red:hover    { background: #a93226; }
//   .pl-btn-dark   { background: #1c0a0a; color: #fff; }
//   .pl-btn-dark:hover   { background: #2e1010; }
//   .pl-btn-blue   { background: #2980b9; color: #fff; }
//   .pl-btn-blue:hover   { background: #2471a3; }
//   .pl-btn-danger { background: #fdecea; color: #a60808; border: 1px solid #f0c0b8; }
//   .pl-btn-danger:hover:not(:disabled) { background: #fbd5d1; }
//   .pl-btn-danger:disabled { opacity: 0.45; cursor: default; }

//   /* download dropdown */
//   .pl-download-wrap { position: relative; }
//   .pl-dropdown-menu {
//     position: absolute;
//     top: calc(100% + 6px);
//     right: 0;
//     background: #fff;
//     border: 1px solid #f0eded;
//     border-radius: 10px;
//     padding: 6px;
//     z-index: 200;
//     min-width: 200px;
//     box-shadow: 0 4px 20px rgba(0,0,0,0.09);
//   }
//   .pl-dropdown-divider { height: 1px; background: #f0eded; margin: 5px 0; }
//   .pl-dropdown-item {
//     display: block; width: 100%;
//     padding: 9px 14px;
//     font-size: 14px;
//     color: #444; background: none; border: none;
//     border-radius: 7px; text-align: left; cursor: pointer;
//     font-family: 'DM Sans', sans-serif;
//   }
//   .pl-dropdown-item:hover { background: #fdf2f1; color: #a60808; }
//   .pl-dropdown-label {
//     font-size: 11px; font-weight: 700; color: #bbb;
//     text-transform: uppercase; letter-spacing: 0.6px;
//     padding: 6px 14px 3px;
//   }

//   /* ── Table card ── */
//   .pl-table-wrap {
//     background: #fff;
//     border-radius: 14px;
//     border: 1px solid #f0eded;
//     overflow: hidden;
//   }
//   .pl-table-scroll { overflow-x: auto; }
//   .pl-table {
//     width: 100%;
//     border-collapse: collapse;
//     font-size: 15px;
//   }
//   .pl-table thead tr { background: #fdf2f1; }
//   .pl-table th {
//     padding: 14px 16px;
//     text-align: left;
//     font-size: 12px;
//     font-weight: 700;
//     color: #a60808;
//     text-transform: uppercase;
//     letter-spacing: 0.6px;
//     white-space: nowrap;
//   }
//   .pl-table th.center,
//   .pl-table td.center { text-align: center; }
//   .pl-table td {
//     padding: 14px 16px;
//     color: #444;
//     border-top: 1px solid #f7f5f5;
//     vertical-align: middle;
//     font-size: 15px;
//   }
//   .pl-table tbody tr:hover td { background: #fdfafa; }

//   /* checkbox */
//   .pl-check {
//     width: 16px; height: 16px;
//     accent-color: #a60808;
//     cursor: pointer;
//   }
//   .pl-check-label {
//     display: flex; align-items: center; gap: 7px;
//     font-size: 13px; color: #888; cursor: pointer;
//     white-space: nowrap;
//   }

//   /* product cell */
//   .pl-prod-cell { display: flex; align-items: center; gap: 12px; }
//   .pl-prod-img {
//     width: 48px; height: 48px;
//     border-radius: 10px;
//     object-fit: cover;
//     border: 1px solid #f0eded;
//     background: #fdf2f1;
//     flex-shrink: 0;
//   }
//   .pl-prod-name {
//     font-size: 15px; font-weight: 600; color: #1c0a0a;
//     max-width: 200px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
//   }

//   /* category chip */
//   .pl-cat-chip {
//     display: inline-block;
//     font-size: 12px; font-weight: 600;
//     background: #fdf2f1; color: #a60808;
//     padding: 3px 10px; border-radius: 20px;
//     border: 1px solid #f0c0b8;
//   }

//   /* price */
//   .pl-price-main {
//     font-size: 16px; font-weight: 700; color: #1c0a0a;
//     font-family: 'JetBrains Mono', monospace;
//   }
//   .pl-price-strike {
//     font-size: 13px; color: #bbb;
//     text-decoration: line-through;
//     font-family: 'JetBrains Mono', monospace;
//     margin-top: 2px;
//   }

//   /* stock badge */
//   .pl-stock {
//     display: inline-flex; align-items: center;
//     font-size: 14px; font-weight: 600;
//     font-family: 'JetBrains Mono', monospace;
//     color: #1c0a0a;
//   }

//   /* status badge */
//   .pl-badge {
//     display: inline-flex; align-items: center; gap: 5px;
//     font-size: 12.5px; font-weight: 700;
//     padding: 4px 12px; border-radius: 20px;
//     cursor: pointer; transition: opacity 0.15s;
//   }
//   .pl-badge:hover { opacity: 0.8; }
//   .pl-badge.active { background: #e8f8ef; color: #27ae60; border: 1px solid #b7e4c7; }
//   .pl-badge.inactive { background: #fff5e6; color: #e67e22; border: 1px solid #fcd9a0; }

//   /* view btn */
//   .pl-view-btn {
//     height: 34px; padding: 0 16px;
//     border-radius: 9px;
//     border: 1px solid #f0eded; background: #fff;
//     font-size: 14px; color: #555;
//     cursor: pointer;
//     display: inline-flex; align-items: center; gap: 5px;
//     transition: all 0.18s;
//     font-family: 'DM Sans', sans-serif;
//   }
//   .pl-view-btn:hover { background: #fdf2f1; border-color: #f0c0b8; color: #a60808; }

//   /* sr no */
//   .pl-sr { font-size: 13px; color: #bbb; font-family: 'JetBrains Mono', monospace; }

//   /* skeleton */
//   .pl-skel-cell { padding: 14px 16px; border-top: 1px solid #f7f5f5; }

//   /* pagination */
//   .pl-pagination {
//     display: flex; align-items: center; justify-content: space-between;
//     flex-wrap: wrap; gap: 12px;
//     padding: 16px 22px;
//     border-top: 1px solid #f7f5f5;
//   }
//   .pl-show-row { display: flex; align-items: center; gap: 8px; font-size: 14px; color: #888; }
//   .pl-page-btns { display: flex; align-items: center; gap: 5px; }
//   .pl-pg-btn {
//     width: 36px; height: 36px;
//     border-radius: 9px;
//     border: 1px solid #f0eded; background: #fff;
//     font-size: 14px; color: #555;
//     cursor: pointer;
//     display: flex; align-items: center; justify-content: center;
//     transition: all 0.18s;
//     font-family: 'DM Sans', sans-serif;
//   }
//   .pl-pg-btn.active { background: #a60808; color: #fff; border-color: #a60808; }
//   .pl-pg-btn:hover:not(.active):not(:disabled) { background: #fdf2f1; color: #a60808; }
//   .pl-pg-btn:disabled { opacity: 0.4; cursor: default; }

//   /* ── Modal ── */
//   .pl-modal-overlay {
//     position: fixed; inset: 0;
//     background: rgba(28,10,10,0.45);
//     display: flex; align-items: center; justify-content: center;
//     z-index: 1050;
//   }
//   .pl-modal {
//     background: #fff;
//     border-radius: 18px;
//     width: 400px;
//     max-width: 95vw;
//     overflow: hidden;
//     box-shadow: 0 20px 60px rgba(0,0,0,0.18);
//     font-family: 'DM Sans', sans-serif;
//   }
//   .pl-modal-header {
//     display: flex; align-items: center; justify-content: space-between;
//     padding: 20px 24px 16px;
//     border-bottom: 1px solid #f0eded;
//   }
//   .pl-modal-title { font-size: 17px; font-weight: 700; color: #1c0a0a; }
//   .pl-modal-close {
//     width: 32px; height: 32px;
//     border-radius: 8px; border: 1px solid #f0eded;
//     background: #f9f9f9; cursor: pointer;
//     display: flex; align-items: center; justify-content: center;
//     color: #888; font-size: 16px; transition: all 0.15s;
//   }
//   .pl-modal-close:hover { background: #fdf2f1; color: #a60808; border-color: #f0c0b8; }
//   .pl-modal-body { padding: 22px 24px; }
//   .pl-modal-footer { padding: 16px 24px; border-top: 1px solid #f0eded; display: flex; justify-content: flex-end; gap: 10px; }

//   .pl-field-label {
//     font-size: 12px; font-weight: 700; color: #888;
//     text-transform: uppercase; letter-spacing: 0.5px;
//     margin-bottom: 6px; display: block;
//   }
//   .pl-field-input {
//     width: 100%;
//     height: 42px;
//     border-radius: 10px;
//     border: 1px solid #f0eded;
//     padding: 0 14px;
//     font-size: 15px;
//     color: #1c0a0a;
//     background: #f9f9f9;
//     outline: none;
//     font-family: 'DM Sans', sans-serif;
//     margin-bottom: 14px;
//   }
//   .pl-field-input:focus { border-color: #f0c0b8; }
//   .pl-field-input[readonly] { color: #999; }

//   .pl-preview-img {
//     width: 100%; height: 180px;
//     object-fit: contain;
//     border-radius: 10px;
//     border: 1px solid #f0eded;
//     background: #f9f9f9;
//     margin-bottom: 16px;
//   }
// `;

// const STAT_ICONS = ["🛍️", "✅", "⏸️"];

// function ProductList() {

//    const getImageUrl = (image) => {
//       if (!image) return "";
//       if (image.startsWith("http")) return image;
//       return `${IMAGE_BASE_URL}${image}`;
//     };

//   const navigate = useNavigate();
//   const [list, setList] = useState([]);
//   const [statics, setStatics] = useState(null);
//   const [showBulkModal, setShowBulkModal] = useState(false);
//   const [bulkForm, setBulkForm] = useState({ name: "", file: null });
//   const [isUploading, setIsUploading] = useState(false);
//   const [showDownloadMenu, setShowDownloadMenu] = useState(false);
//   const [payload, setPayload] = useState({
//     searchKey: "", status: "", pageNo: 1, pageCount: 10, categoryId: "", sortByField: "",
//   });
//   const [showSkelton, setShowSkelton] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [editFormData, setEditFormData] = useState({ name: "", productHeroImage: "", status: "", _id: "" });
//   const [categoryList, setCategoryList] = useState([]);
//   const [selectedProducts, setSelectedProducts] = useState([]);
//   const [totalPages, setTotalPages] = useState(1);

//   const handleGetProductFunc = async () => {
//     if (list.length === 0) setShowSkelton(true);
//     try {
//       let response = await getProductServ(payload);
//       setList(response?.data?.data);
//       setStatics(response?.data?.documentCount);
//     } catch (error) {}
//     setShowSkelton(false);
//   };

//   useEffect(() => { handleGetProductFunc(); }, [payload]);
//   useEffect(() => { getCategoryList(); }, []);

//   const getCategoryList = async () => {
//     try {
//       let res = await getCategoryServ();
//       setCategoryList(res?.data?.data || []);
//     } catch (err) {}
//   };

//   useEffect(() => {
//     if (statics?.totalCount && payload.pageCount) {
//       setTotalPages(Math.ceil(statics.totalCount / payload.pageCount));
//     }
//   }, [statics, payload.pageCount]);

//   const handlePageChange = (newPage) => {
//     if (newPage >= 1 && newPage <= totalPages) setPayload({ ...payload, pageNo: newPage });
//   };

//   const updateProductFunc = async () => {
//     try {
//       let response = await updateProductServ({ id: editFormData?._id, status: editFormData?.status });
//       if (response?.data?.statusCode == "200") {
//         toast.success(response?.data?.message);
//         setEditFormData({ name: "", productHeroImage: "", status: "", _id: "" });
//         handleGetProductFunc();
//       }
//     } catch (error) {
//       toast.error("Internal Server Error");
//     }
//   };

//   const handleBulkUpload = async () => {
//     if (!bulkForm.name || !bulkForm.file) { toast.error("Please enter a name and select a file"); return; }
//     setIsUploading(true);
//     const formData = new FormData();
//     formData.append("file", bulkForm.file);
//     try {
//       const res = await uploadExcelServ(formData);
//       if (res?.data?.statusCode === 200) {
//         toast.success(res?.data?.message || "Bulk upload successful!");
//         setShowBulkModal(false);
//         setBulkForm({ name: "", file: null });
//         handleGetProductFunc();
//       } else {
//         toast.error(res?.data?.message || "Upload failed");
//       }
//     } catch (err) {
//       const errorData = err?.response?.data;
//       toast.error(errorData?.message || "Server Error during upload");
//     } finally {
//       setIsUploading(false);
//     }
//   };

//   const handleDownload = async (format) => {
//     setShowDownloadMenu(false);
//     try {
//       const response = await downloadProductExportServ(payload, format);
//       const ext = format === "excel" ? "xlsx" : format;
//       triggerFileDownload(response.data, `productList.${ext}`);
//     } catch (err) { toast.error("Download failed"); }
//   };

//   const handleDownloadSample = async (format) => {
//     setShowDownloadMenu(false);
//     try {
//       const res = await downloadSampleProductFileServ(format);
//       const ext = format === "excel" ? "xlsx" : format;
//       triggerFileDownload(res.data, `BulkProductUploadTemplate.${ext}`);
//     } catch (err) { toast.error("Sample file download failed"); }
//   };

//   const staticsArr = [
//     { title: "Total Products",    count: statics?.totalCount,    icon: STAT_ICONS[0] },
//     { title: "Active Products",   count: statics?.activeCount,   icon: STAT_ICONS[1] },
//     { title: "Inactive Products", count: statics?.inactiveCount, icon: STAT_ICONS[2] },
//   ];

//   return (
//     <div className="bodyContainer">
//       <style>{styles}</style>
//       <Sidebar selectedMenu="Product Management" selectedItem="Products" />
//       <div className="mainContainer">
//         <TopNav pageTitle="Products" pagePath="Home / Product Management / Products" />
//         <div className="pl-root">

//           {/* ── Stat Cards ── */}
//           <div className="pl-stat-grid">
//             {staticsArr.map((v, i) => (
//               <div className="pl-stat-card" key={i}>
//                 <div className="pl-stat-icon">{v.icon}</div>
//                 <div>
//                   <div className="pl-stat-val">{v.count ?? "—"}</div>
//                   <div className="pl-stat-lbl">{v.title}</div>
//                 </div>
//               </div>
//             ))}
//           </div>

//           {/* ── Toolbar ── */}
//           <div className="pl-toolbar">
//             <div className="pl-toolbar-title">Products</div>

//             <input
//               className="pl-input"
//               placeholder="🔍  Search products..."
//               onChange={(e) => setPayload({ ...payload, searchKey: e.target.value })}
//             />

//             <select className="pl-select" onChange={(e) => setPayload({ ...payload, status: e.target.value })}>
//               <option value="">All Status</option>
//               <option value={true}>Active</option>
//               <option value={false}>Inactive</option>
//             </select>

//             <select
//               className="pl-select"
//               onChange={(e) => setPayload({ ...payload, categoryId: e.target.value })}
//               value={payload.categoryId}
//             >
//               <option value="">All Categories</option>
//               {categoryList?.map((cat) => (
//                 <option key={cat._id} value={cat._id}>{cat.name}</option>
//               ))}
//             </select>

//             <button className="pl-btn pl-btn-red" onClick={() => navigate("/add-product")}>
//               <i className="ti ti-plus" /> Add Product
//             </button>

//             <button className="pl-btn pl-btn-dark" onClick={() => setShowBulkModal(true)}>
//               <i className="ti ti-upload" /> Bulk Upload
//             </button>

//             <div className="pl-download-wrap">
//               <button className="pl-btn pl-btn-blue" onClick={() => setShowDownloadMenu((p) => !p)}>
//                 <i className="ti ti-download" /> Download
//               </button>
//               {showDownloadMenu && (
//                 <div className="pl-dropdown-menu">
//                   <div className="pl-dropdown-label">Export List</div>
//                   <button className="pl-dropdown-item" onClick={() => handleDownload("txt")}>Download as TXT</button>
//                   <button className="pl-dropdown-item" onClick={() => handleDownload("excel")}>Download as Excel</button>
//                   <button className="pl-dropdown-item" onClick={() => handleDownload("csv")}>Download as CSV</button>
//                   <div className="pl-dropdown-divider" />
//                   <div className="pl-dropdown-label">Sample Templates</div>
//                   <button className="pl-dropdown-item" onClick={() => handleDownloadSample("excel")}>Sample Excel</button>
//                   <button className="pl-dropdown-item" onClick={() => handleDownloadSample("csv")}>Sample CSV</button>
//                   <button className="pl-dropdown-item" onClick={() => handleDownloadSample("txt")}>Sample TXT</button>
//                 </div>
//               )}
//             </div>

//             <button
//               className="pl-btn pl-btn-danger"
//               disabled={selectedProducts.length === 0}
//               onClick={async () => {
//                 if (window.confirm(`Delete ${selectedProducts.length} product(s)?`)) {
//                   try {
//                     const res = await bulkDeleteProductsServ(selectedProducts);
//                     toast.success(res.data.message);
//                     setSelectedProducts([]);
//                     handleGetProductFunc();
//                   } catch (err) { toast.error("Bulk delete failed"); }
//                 }
//               }}
//             >
//               <i className="ti ti-trash" />
//               Delete {selectedProducts.length > 0 ? `(${selectedProducts.length})` : "Selected"}
//             </button>
//           </div>

//           {/* ── Table ── */}
//           <div className="pl-table-wrap">
//             <div className="pl-table-scroll">
//               <table className="pl-table">
//                 <thead>
//                   <tr>
//                     <th>
//                       <label className="pl-check-label">
//                         <input
//                           type="checkbox"
//                           className="pl-check"
//                           checked={list.length > 0 && selectedProducts.length === list.length}
//                           onChange={(e) => setSelectedProducts(e.target.checked ? list.map((p) => p._id) : [])}
//                         />
//                         All
//                       </label>
//                     </th>
//                     <th>#</th>
//                     <th>Product</th>
//                     <th>Category</th>
//                     <th>Price</th>
//                     <th className="center">Stock</th>
//                     <th className="center">Status</th>
//                     <th className="center">Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {showSkelton ? (
//                     [...Array(10)].map((_, i) => (
//                       <tr key={i}>
//                         {[...Array(8)].map((__, j) => (
//                           <td key={j} className="pl-skel-cell"><Skeleton height={20} /></td>
//                         ))}
//                       </tr>
//                     ))
//                   ) : list?.length === 0 ? (
//                     <tr>
//                       <td colSpan="8" style={{ textAlign: "center", padding: "50px" }}>
//                         <NoRecordFound />
//                       </td>
//                     </tr>
//                   ) : (
//                     list.map((v, i) => (
//                       <tr key={v._id}>
//                         {/* Checkbox */}
//                         <td>
//                           <label className="pl-check-label">
//                             <input
//                               type="checkbox"
//                               className="pl-check"
//                               checked={selectedProducts.includes(v._id)}
//                               onChange={(e) => {
//                                 if (e.target.checked) setSelectedProducts([...selectedProducts, v._id]);
//                                 else setSelectedProducts(selectedProducts.filter((id) => id !== v._id));
//                               }}
//                             />
//                           </label>
//                         </td>

//                         {/* Sr */}
//                         <td>
//                           <span className="pl-sr">
//                             {(payload.pageNo - 1) * payload.pageCount + i + 1}
//                           </span>
//                         </td>

//                         {/* Product */}
//                         <td>
//                           <div className="pl-prod-cell">
//                          <img src={getImageUrl(v?.productHeroImage)} alt="" className="pl-prod-img" />
//                             <div className="pl-prod-name">{v?.name}</div>
//                           </div>
//                         </td>

//                         {/* Category */}
//                         <td>
//                           <span className="pl-cat-chip">
//                             {Array.isArray(v?.categoryId)
//                               ? v.categoryId.map((cat) => cat.name).join(", ")
//                               : v?.categoryId?.name || "—"}
//                           </span>
//                         </td>

//                         {/* Price */}
//                         <td>
//                           <div className="pl-price-main">
//                             Rs {v?.discountedPrice || v?.price || "—"}
//                           </div>
//                           {v?.discountedPrice && v?.price && (
//                             <div className="pl-price-strike">Rs {v?.price}</div>
//                           )}
//                         </td>

//                         {/* Stock */}
//                         <td className="center">
//                           <span className="pl-stock">{v?.stockQuantity ?? "—"}</span>
//                         </td>

//                         {/* Status */}
//                         <td className="center">
//                           {v?.status ? (
//                             <span
//                               className="pl-badge active"
//                               onClick={() => setEditFormData({ name: v?.name, productHeroImage: v?.productHeroImage, status: true, _id: v?._id })}
//                             >
//                               <i className="ti ti-circle-check" style={{ fontSize: 13 }} /> Active
//                             </span>
//                           ) : (
//                             <span
//                               className="pl-badge inactive"
//                               onClick={() => setEditFormData({ name: v?.name, productHeroImage: v?.productHeroImage, status: false, _id: v?._id })}
//                             >
//                               <i className="ti ti-circle-x" style={{ fontSize: 13 }} /> Inactive
//                             </span>
//                           )}
//                         </td>

//                         {/* Action */}
//                         <td className="center">
//                           <button
//                             className="pl-view-btn"
//                             onClick={() => navigate(`/product-details/${v?._id}`)}
//                           >
//                             <i className="ti ti-eye" /> View
//                           </button>
//                         </td>
//                       </tr>
//                     ))
//                   )}
//                 </tbody>
//               </table>
//             </div>

//             {/* ── Pagination ── */}
//             <div className="pl-pagination">
//               <div className="pl-show-row">
//                 Show
//                 <select
//                   className="pl-select"
//                   style={{ height: "34px", padding: "0 10px", minWidth: "unset" }}
//                   value={payload.pageCount}
//                   onChange={(e) => setPayload({ ...payload, pageCount: parseInt(e.target.value), pageNo: 1 })}
//                 >
//                   {[10, 25, 50, 100].map((v) => (
//                     <option key={v} value={v}>{v}</option>
//                   ))}
//                 </select>
//                 entries
//               </div>

//               <div className="pl-page-btns">
//                 <button className="pl-pg-btn" disabled={payload.pageNo === 1} onClick={() => handlePageChange(payload.pageNo - 1)}>
//                   <i className="ti ti-chevron-left" style={{ fontSize: 14 }} />
//                 </button>
//                 {[...Array(totalPages)].map((_, i) => {
//                   const page = i + 1;
//                   if (page === 1 || page === totalPages || (page >= payload.pageNo - 1 && page <= payload.pageNo + 1)) {
//                     return (
//                       <button key={page} className={`pl-pg-btn ${payload.pageNo === page ? "active" : ""}`} onClick={() => handlePageChange(page)}>
//                         {page}
//                       </button>
//                     );
//                   } else if ((page === payload.pageNo - 2 && page > 2) || (page === payload.pageNo + 2 && page < totalPages - 1)) {
//                     return <button key={page} className="pl-pg-btn" disabled>…</button>;
//                   }
//                   return null;
//                 })}
//                 <button className="pl-pg-btn" disabled={payload.pageNo === totalPages} onClick={() => handlePageChange(payload.pageNo + 1)}>
//                   <i className="ti ti-chevron-right" style={{ fontSize: 14 }} />
//                 </button>
//               </div>
//             </div>
//           </div>

//         </div>
//       </div>

//       {/* ── Edit Status Modal ── */}
//       {editFormData?._id && (
//         <div className="pl-modal-overlay" onClick={() => setEditFormData({ name: "", productHeroImage: "", status: "", _id: "" })}>
//           <div className="pl-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="pl-modal-header">
//               <div className="pl-modal-title">Update Product Status</div>
//               <button className="pl-modal-close" onClick={() => setEditFormData({ name: "", productHeroImage: "", status: "", _id: "" })}>
//                 <i className="ti ti-x" />
//               </button>
//             </div>
//             <div className="pl-modal-body">
//             <img src={getImageUrl(editFormData?.productHeroImage)} alt="" className="pl-preview-img" />
//               <label className="pl-field-label">Product Name</label>
//               <input className="pl-field-input" readOnly value={editFormData?.name} />
//               <label className="pl-field-label">Status</label>
//               <select
//                 className="pl-field-input"
//                 style={{ cursor: "pointer" }}
//                 value={editFormData?.status}
//                 onChange={(e) => setEditFormData({ ...editFormData, status: e.target.value })}
//               >
//                 <option value="">Select Status</option>
//                 <option value={true}>Active</option>
//                 <option value={false}>Inactive</option>
//               </select>
//             </div>
//             <div className="pl-modal-footer">
//               <button
//                 className="pl-btn"
//                 style={{ background: "#f0eded", color: "#555" }}
//                 onClick={() => setEditFormData({ name: "", productHeroImage: "", status: "", _id: "" })}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="pl-btn pl-btn-red"
//                 disabled={!editFormData?.status || isLoading}
//                 style={{ opacity: !editFormData?.status ? 0.5 : 1 }}
//                 onClick={!isLoading ? updateProductFunc : undefined}
//               >
//                 {isLoading ? "Saving…" : "Update Status"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ── Bulk Upload Modal ── */}
//       {showBulkModal && (
//         <div className="pl-modal-overlay" onClick={() => setShowBulkModal(false)}>
//           <div className="pl-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="pl-modal-header">
//               <div className="pl-modal-title">Bulk Upload Products</div>
//               <button className="pl-modal-close" onClick={() => setShowBulkModal(false)}>
//                 <i className="ti ti-x" />
//               </button>
//             </div>
//             <div className="pl-modal-body">
//               <label className="pl-field-label">Bulk Name</label>
//               <input
//                 className="pl-field-input"
//                 type="text"
//                 placeholder="Enter a name for this upload batch"
//                 value={bulkForm.name}
//                 onChange={(e) => setBulkForm({ ...bulkForm, name: e.target.value })}
//               />
//               <label className="pl-field-label">Upload File (CSV / Excel)</label>
//               <input
//                 className="pl-field-input"
//                 type="file"
//                 style={{ height: "auto", padding: "10px 14px" }}
//                 accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
//                 onChange={(e) => setBulkForm({ ...bulkForm, file: e.target.files[0] })}
//               />
//             </div>
//             <div className="pl-modal-footer">
//               <button className="pl-btn" style={{ background: "#f0eded", color: "#555" }} onClick={() => setShowBulkModal(false)}>
//                 Cancel
//               </button>
//               <button
//                 className="pl-btn pl-btn-red"
//                 disabled={isUploading || !bulkForm.name || !bulkForm.file}
//                 style={{ opacity: !bulkForm.name || !bulkForm.file ? 0.5 : 1 }}
//                 onClick={handleBulkUpload}
//               >
//                 {isUploading ? (
//                   <><span className="spinner-border spinner-border-sm me-1" /> Uploading…</>
//                 ) : (
//                   <><i className="ti ti-upload" /> Upload</>
//                 )}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default ProductList;



import React, { useState, useEffect } from "react";
import Sidebar from "../../Components/Sidebar";
import TopNav from "../../Components/TopNav";
import {
  getProductServ,
  updateProductServ,
  deleteProductServ,
  uploadExcelServ,
  downloadProductExportServ,
  downloadSampleProductFileServ,
  bulkDeleteProductsServ,
} from "../../services/product.services";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import NoRecordFound from "../../Components/NoRecordFound";
import { useNavigate } from "react-router-dom";
import { getCategoryServ } from "../../services/category.service";
import { triggerFileDownload } from "../../utils/fileDownload";


import { IMAGE_BASE_URL } from "../../utils/api_base_url_configration";

/* ─── Scoped styles — same design language as OrderList ─── */
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=JetBrains+Mono:wght@500;600&display=swap');

  .pl-root {
    background: #f5f5f7;
    min-height: 100%;
    padding: 28px;
    font-family: 'DM Sans', 'Segoe UI', sans-serif;
  }

  /* ── Stat grid ── */
  .pl-stat-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 14px;
    margin-bottom: 22px;
  }
  @media (max-width: 900px)  { .pl-stat-grid { grid-template-columns: repeat(2,1fr); } }
  @media (max-width: 560px)  { .pl-stat-grid { grid-template-columns: 1fr; } }

  .pl-stat-card {
    background: #fff;
    border-radius: 14px;
    padding: 18px 20px;
    border: 1px solid #f0eded;
    display: flex;
    align-items: center;
    gap: 16px;
  }
  .pl-stat-icon {
    width: 46px; height: 46px;
    border-radius: 12px;
    background: #fdf2f1;
    display: flex; align-items: center; justify-content: center;
    font-size: 22px;
    color: #a60808;
    flex-shrink: 0;
  }
  .pl-stat-val {
    font-size: 26px;
    font-weight: 700;
    color: #1c0a0a;
    line-height: 1;
    font-family: 'JetBrains Mono', monospace;
  }
  .pl-stat-lbl {
    font-size: 14px;
    color: #828282;
    margin-top: 5px;
    font-weight: 500;
  }

  /* ── Toolbar ── */
  .pl-toolbar {
    background: #fff;
    border-radius: 14px;
    padding: 18px 22px;
    border: 1px solid #f0eded;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 16px;
  }
  .pl-toolbar-title {
    font-size: 20px;
    font-weight: 700;
    color: #1c0a0a;
    margin-right: auto;
  }

  .pl-input {
    height: 40px;
    border-radius: 10px;
    border: 1px solid #f0eded;
    padding: 0 14px;
    font-size: 14px;
    color: #444;
    background: #f9f9f9;
    outline: none;
    min-width: 170px;
    font-family: 'DM Sans', sans-serif;
  }
  .pl-input:focus { border-color: #f0c0b8; }
  .pl-input::placeholder { color: #bbb; }

  .pl-select {
    height: 40px;
    border-radius: 10px;
    border: 1px solid #f0eded;
    padding: 0 14px;
    font-size: 14px;
    color: #555;
    background: #f9f9f9;
    outline: none;
    cursor: pointer;
    font-family: 'DM Sans', sans-serif;
  }
  .pl-select:focus { border-color: #f0c0b8; }

  /* buttons */
  .pl-btn {
    height: 40px;
    padding: 0 18px;
    border-radius: 10px;
    border: none;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    display: inline-flex; align-items: center; gap: 7px;
    white-space: nowrap;
    transition: all 0.18s;
    font-family: 'DM Sans', sans-serif;
  }
  .pl-btn-red    { background: #a60808; color: #fff; }
  .pl-btn-red:hover    { background: #a93226; }
  .pl-btn-dark   { background: #1c0a0a; color: #fff; }
  .pl-btn-dark:hover   { background: #2e1010; }
  .pl-btn-blue   { background: #2980b9; color: #fff; }
  .pl-btn-blue:hover   { background: #2471a3; }
  .pl-btn-danger { background: #fdecea; color: #a60808; border: 1px solid #f0c0b8; }
  .pl-btn-danger:hover:not(:disabled) { background: #fbd5d1; }
  .pl-btn-danger:disabled { opacity: 0.45; cursor: default; }

  /* download dropdown */
  .pl-download-wrap { position: relative; }
  .pl-dropdown-menu {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    background: #fff;
    border: 1px solid #f0eded;
    border-radius: 10px;
    padding: 6px;
    z-index: 200;
    min-width: 200px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.09);
  }
  .pl-dropdown-divider { height: 1px; background: #f0eded; margin: 5px 0; }
  .pl-dropdown-item {
    display: block; width: 100%;
    padding: 9px 14px;
    font-size: 14px;
    color: #444; background: none; border: none;
    border-radius: 7px; text-align: left; cursor: pointer;
    font-family: 'DM Sans', sans-serif;
  }
  .pl-dropdown-item:hover { background: #fdf2f1; color: #a60808; }
  .pl-dropdown-label {
    font-size: 11px; font-weight: 700; color: #bbb;
    text-transform: uppercase; letter-spacing: 0.6px;
    padding: 6px 14px 3px;
  }

  /* ── Table card ── */
  .pl-table-wrap {
    background: #fff;
    border-radius: 14px;
    border: 1px solid #f0eded;
    overflow: hidden;
  }
  .pl-table-scroll { overflow-x: auto; }
  .pl-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 15px;
  }
  .pl-table thead tr { background: #fdf2f1; }
  .pl-table th {
    padding: 14px 16px;
    text-align: left;
    font-size: 12px;
    font-weight: 700;
    color: #a60808;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    white-space: nowrap;
  }
  .pl-table th.center,
  .pl-table td.center { text-align: center; }
  .pl-table td {
    padding: 14px 16px;
    color: #444;
    border-top: 1px solid #f7f5f5;
    vertical-align: middle;
    font-size: 15px;
  }
  .pl-table tbody tr:hover td { background: #fdfafa; }

  /* checkbox */
  .pl-check {
    width: 16px; height: 16px;
    accent-color: #a60808;
    cursor: pointer;
  }
  .pl-check-label {
    display: flex; align-items: center; gap: 7px;
    font-size: 13px; color: #888; cursor: pointer;
    white-space: nowrap;
  }

  /* product cell */
  .pl-prod-cell { display: flex; align-items: center; gap: 12px; }
  .pl-prod-img {
    width: 48px; height: 48px;
    border-radius: 10px;
    object-fit: cover;
    border: 1px solid #f0eded;
    background: #fdf2f1;
    flex-shrink: 0;
  }
  .pl-prod-name {
    font-size: 15px; font-weight: 600; color: #1c0a0a;
    max-width: 200px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  }

  /* category chip */
  .pl-cat-chip {
    display: inline-block;
    font-size: 12px; font-weight: 600;
    background: #fdf2f1; color: #a60808;
    padding: 3px 10px; border-radius: 20px;
    border: 1px solid #f0c0b8;
  }

  /* price */
  .pl-price-main {
    font-size: 16px; font-weight: 700; color: #1c0a0a;
    font-family: 'JetBrains Mono', monospace;
  }
  .pl-price-strike {
    font-size: 13px; color: #bbb;
    text-decoration: line-through;
    font-family: 'JetBrains Mono', monospace;
    margin-top: 2px;
  }

  /* stock badge */
  .pl-stock {
    display: inline-flex; align-items: center;
    font-size: 14px; font-weight: 600;
    font-family: 'JetBrains Mono', monospace;
    color: #1c0a0a;
  }

  /* status badge */
  .pl-badge {
    display: inline-flex; align-items: center; gap: 5px;
    font-size: 12.5px; font-weight: 700;
    padding: 4px 12px; border-radius: 20px;
    cursor: pointer; transition: opacity 0.15s;
  }
  .pl-badge:hover { opacity: 0.8; }
  .pl-badge.active { background: #e8f8ef; color: #27ae60; border: 1px solid #b7e4c7; }
  .pl-badge.inactive { background: #fff5e6; color: #e67e22; border: 1px solid #fcd9a0; }

  /* view btn */
  .pl-view-btn {
    height: 34px; padding: 0 16px;
    border-radius: 9px;
    border: 1px solid #f0eded; background: #fff;
    font-size: 14px; color: #555;
    cursor: pointer;
    display: inline-flex; align-items: center; gap: 5px;
    transition: all 0.18s;
    font-family: 'DM Sans', sans-serif;
  }
  .pl-view-btn:hover { background: #fdf2f1; border-color: #f0c0b8; color: #a60808; }

  /* sr no */
  .pl-sr { font-size: 13px; color: #bbb; font-family: 'JetBrains Mono', monospace; }

  /* skeleton */
  .pl-skel-cell { padding: 14px 16px; border-top: 1px solid #f7f5f5; }

  /* pagination */
  .pl-pagination {
    display: flex; align-items: center; justify-content: space-between;
    flex-wrap: wrap; gap: 12px;
    padding: 16px 22px;
    border-top: 1px solid #f7f5f5;
  }
  .pl-show-row { display: flex; align-items: center; gap: 8px; font-size: 14px; color: #888; }
  .pl-page-btns { display: flex; align-items: center; gap: 5px; }
  .pl-pg-btn {
    width: 36px; height: 36px;
    border-radius: 9px;
    border: 1px solid #f0eded; background: #fff;
    font-size: 14px; color: #555;
    cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    transition: all 0.18s;
    font-family: 'DM Sans', sans-serif;
  }
  .pl-pg-btn.active { background: #a60808; color: #fff; border-color: #a60808; }
  .pl-pg-btn:hover:not(.active):not(:disabled) { background: #fdf2f1; color: #a60808; }
  .pl-pg-btn:disabled { opacity: 0.4; cursor: default; }

  /* ── Modal ── */
  .pl-modal-overlay {
    position: fixed; inset: 0;
    background: rgba(28,10,10,0.45);
    display: flex; align-items: center; justify-content: center;
    z-index: 1050;
  }
  .pl-modal {
    background: #fff;
    border-radius: 18px;
    width: 400px;
    max-width: 95vw;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0,0,0,0.18);
    font-family: 'DM Sans', sans-serif;
  }
  .pl-modal-header {
    display: flex; align-items: center; justify-content: space-between;
    padding: 20px 24px 16px;
    border-bottom: 1px solid #f0eded;
  }
  .pl-modal-title { font-size: 17px; font-weight: 700; color: #1c0a0a; }
  .pl-modal-close {
    width: 32px; height: 32px;
    border-radius: 8px; border: 1px solid #f0eded;
    background: #f9f9f9; cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    color: #888; font-size: 16px; transition: all 0.15s;
  }
  .pl-modal-close:hover { background: #fdf2f1; color: #a60808; border-color: #f0c0b8; }
  .pl-modal-body { padding: 22px 24px; }
  .pl-modal-footer { padding: 16px 24px; border-top: 1px solid #f0eded; display: flex; justify-content: flex-end; gap: 10px; }

  .pl-field-label {
    font-size: 12px; font-weight: 700; color: #888;
    text-transform: uppercase; letter-spacing: 0.5px;
    margin-bottom: 6px; display: block;
  }
  .pl-field-input {
    width: 100%;
    height: 42px;
    border-radius: 10px;
    border: 1px solid #f0eded;
    padding: 0 14px;
    font-size: 15px;
    color: #1c0a0a;
    background: #f9f9f9;
    outline: none;
    font-family: 'DM Sans', sans-serif;
    margin-bottom: 14px;
  }
  .pl-field-input:focus { border-color: #f0c0b8; }
  .pl-field-input[readonly] { color: #999; }

  .pl-preview-img {
    width: 100%; height: 180px;
    object-fit: contain;
    border-radius: 10px;
    border: 1px solid #f0eded;
    background: #f9f9f9;
    margin-bottom: 16px;
  }
`;

const STAT_ICONS = ["🛍️", "✅", "⏸️"];

function ProductList() {

   const getImageUrl = (image) => {
      if (!image) return "";
      if (image.startsWith("http")) return image;
      return `${IMAGE_BASE_URL}${image}`;
    };

  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [statics, setStatics] = useState(null);
  const [showBulkModal, setShowBulkModal] = useState(false);
  // const [bulkForm, setBulkForm] = useState({ name: "", file: null });
  const [bulkForm, setBulkForm] = useState({ name: "", file: null, images: [] });
  const [isUploading, setIsUploading] = useState(false);
  const [showDownloadMenu, setShowDownloadMenu] = useState(false);
  const [payload, setPayload] = useState({
    searchKey: "", status: "", pageNo: 1, pageCount: 10, categoryId: "", sortByField: "",
  });
  const [showSkelton, setShowSkelton] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [editFormData, setEditFormData] = useState({ name: "", productHeroImage: "", status: "", _id: "" });
  const [categoryList, setCategoryList] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [totalPages, setTotalPages] = useState(1);

  const handleGetProductFunc = async () => {
    if (list.length === 0) setShowSkelton(true);
    try {
      let response = await getProductServ(payload);
      setList(response?.data?.data);
      setStatics(response?.data?.documentCount);
    } catch (error) {}
    setShowSkelton(false);
  };

  useEffect(() => { handleGetProductFunc(); }, [payload]);
  useEffect(() => { getCategoryList(); }, []);

  const getCategoryList = async () => {
    try {
      let res = await getCategoryServ();
      setCategoryList(res?.data?.data || []);
    } catch (err) {}
  };

  useEffect(() => {
    if (statics?.totalCount && payload.pageCount) {
      setTotalPages(Math.ceil(statics.totalCount / payload.pageCount));
    }
  }, [statics, payload.pageCount]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) setPayload({ ...payload, pageNo: newPage });
  };

  const updateProductFunc = async () => {
    try {
      let response = await updateProductServ({ id: editFormData?._id, status: editFormData?.status });
      if (response?.data?.statusCode == "200") {
        toast.success(response?.data?.message);
        setEditFormData({ name: "", productHeroImage: "", status: "", _id: "" });
        handleGetProductFunc();
      }
    } catch (error) {
      toast.error("Internal Server Error");
    }
  };

  const handleBulkUpload = async () => {
    if (!bulkForm.name || !bulkForm.file) { toast.error("Please enter a name and select a file"); return; }
    setIsUploading(true);
     const formData = new FormData();
  formData.append("file", bulkForm.file);

  // Excel me diya gaya productHeroImage/productGallery path client ke
  // apne computer ka hota hai — server usko access nahi kar sakta.
  // Isliye asli image files yahin, isi request ke saath, bhejni hongi.
  bulkForm.images.forEach((img) => {
    formData.append("images", img);
  });

    try {
      const res = await uploadExcelServ(formData);
      if (res?.data?.statusCode === 200) {
        toast.success(res?.data?.message || "Bulk upload successful!");
        setShowBulkModal(false);
        setBulkForm({ name: "", file: null });
        handleGetProductFunc();
      } else {
        toast.error(res?.data?.message || "Upload failed");
      }
    } catch (err) {
      const errorData = err?.response?.data;
      toast.error(errorData?.message || "Server Error during upload");
    } finally {
      setIsUploading(false);
    }
  };

  const handleDownload = async (format) => {
    setShowDownloadMenu(false);
    try {
      const response = await downloadProductExportServ(payload, format);
      const ext = format === "excel" ? "xlsx" : format;
      triggerFileDownload(response.data, `productList.${ext}`);
    } catch (err) { toast.error("Download failed"); }
  };

  const handleDownloadSample = async (format) => {
    setShowDownloadMenu(false);
    try {
      const res = await downloadSampleProductFileServ(format);
      const ext = format === "excel" ? "xlsx" : format;
      triggerFileDownload(res.data, `BulkProductUploadTemplate.${ext}`);
    } catch (err) { toast.error("Sample file download failed"); }
  };

  const staticsArr = [
    { title: "Total Products",    count: statics?.totalCount,    icon: STAT_ICONS[0] },
    { title: "Active Products",   count: statics?.activeCount,   icon: STAT_ICONS[1] },
    { title: "Inactive Products", count: statics?.inactiveCount, icon: STAT_ICONS[2] },
  ];

  return (
    <div className="bodyContainer">
      <style>{styles}</style>
      <Sidebar selectedMenu="Product Management" selectedItem="Products" />
      <div className="mainContainer">
        <TopNav pageTitle="Products" pagePath="Home / Product Management / Products" />
        <div className="pl-root">

          {/* ── Stat Cards ── */}
          <div className="pl-stat-grid">
            {staticsArr.map((v, i) => (
              <div className="pl-stat-card" key={i}>
                <div className="pl-stat-icon">{v.icon}</div>
                <div>
                  <div className="pl-stat-val">{v.count ?? "—"}</div>
                  <div className="pl-stat-lbl">{v.title}</div>
                </div>
              </div>
            ))}
          </div>

          {/* ── Toolbar ── */}
          <div className="pl-toolbar">
            <div className="pl-toolbar-title">Products</div>

            <input
              className="pl-input"
              placeholder="🔍  Search products..."
              onChange={(e) => setPayload({ ...payload, searchKey: e.target.value })}
            />

            <select className="pl-select" onChange={(e) => setPayload({ ...payload, status: e.target.value })}>
              <option value="">All Status</option>
              <option value={true}>Active</option>
              <option value={false}>Inactive</option>
            </select>

            <select
              className="pl-select"
              onChange={(e) => setPayload({ ...payload, categoryId: e.target.value })}
              value={payload.categoryId}
            >
              <option value="">All Categories</option>
              {categoryList?.map((cat) => (
                <option key={cat._id} value={cat._id}>{cat.name}</option>
              ))}
            </select>

            <button className="pl-btn pl-btn-red" onClick={() => navigate("/add-product")}>
              <i className="ti ti-plus" /> Add Product
            </button>

            <button className="pl-btn pl-btn-dark" onClick={() => setShowBulkModal(true)}>
              <i className="ti ti-upload" /> Bulk Upload
            </button>

            <div className="pl-download-wrap">
              <button className="pl-btn pl-btn-blue" onClick={() => setShowDownloadMenu((p) => !p)}>
                <i className="ti ti-download" /> Download
              </button>
              {showDownloadMenu && (
                <div className="pl-dropdown-menu">
                  <div className="pl-dropdown-label">Export List</div>
                  <button className="pl-dropdown-item" onClick={() => handleDownload("txt")}>Download as TXT</button>
                  <button className="pl-dropdown-item" onClick={() => handleDownload("excel")}>Download as Excel</button>
                  <button className="pl-dropdown-item" onClick={() => handleDownload("csv")}>Download as CSV</button>
                  <div className="pl-dropdown-divider" />
                  <div className="pl-dropdown-label">Sample Templates</div>
                  <button className="pl-dropdown-item" onClick={() => handleDownloadSample("excel")}>Sample Excel</button>
                  <button className="pl-dropdown-item" onClick={() => handleDownloadSample("csv")}>Sample CSV</button>
                  <button className="pl-dropdown-item" onClick={() => handleDownloadSample("txt")}>Sample TXT</button>
                </div>
              )}
            </div>

            <button
              className="pl-btn pl-btn-danger"
              disabled={selectedProducts.length === 0}
              onClick={async () => {
                if (window.confirm(`Delete ${selectedProducts.length} product(s)?`)) {
                  try {
                    const res = await bulkDeleteProductsServ(selectedProducts);
                    toast.success(res.data.message);
                    setSelectedProducts([]);
                    handleGetProductFunc();
                  } catch (err) { toast.error("Bulk delete failed"); }
                }
              }}
            >
              <i className="ti ti-trash" />
              Delete {selectedProducts.length > 0 ? `(${selectedProducts.length})` : "Selected"}
            </button>
          </div>

          {/* ── Table ── */}
          <div className="pl-table-wrap">
            <div className="pl-table-scroll">
              <table className="pl-table">
                <thead>
                  <tr>
                    <th>
                      <label className="pl-check-label">
                        <input
                          type="checkbox"
                          className="pl-check"
                          checked={list.length > 0 && selectedProducts.length === list.length}
                          onChange={(e) => setSelectedProducts(e.target.checked ? list.map((p) => p._id) : [])}
                        />
                        All
                      </label>
                    </th>
                    <th>#</th>
                    <th>Product</th>
                    <th>Category</th>
                    <th>Price</th>
                    <th className="center">Stock</th>
                    <th className="center">Status</th>
                    <th className="center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {showSkelton ? (
                    [...Array(10)].map((_, i) => (
                      <tr key={i}>
                        {[...Array(8)].map((__, j) => (
                          <td key={j} className="pl-skel-cell"><Skeleton height={20} /></td>
                        ))}
                      </tr>
                    ))
                  ) : list?.length === 0 ? (
                    <tr>
                      <td colSpan="8" style={{ textAlign: "center", padding: "50px" }}>
                        <NoRecordFound />
                      </td>
                    </tr>
                  ) : (
                    list.map((v, i) => (
                      <tr key={v._id}>
                        {/* Checkbox */}
                        <td>
                          <label className="pl-check-label">
                            <input
                              type="checkbox"
                              className="pl-check"
                              checked={selectedProducts.includes(v._id)}
                              onChange={(e) => {
                                if (e.target.checked) setSelectedProducts([...selectedProducts, v._id]);
                                else setSelectedProducts(selectedProducts.filter((id) => id !== v._id));
                              }}
                            />
                          </label>
                        </td>

                        {/* Sr */}
                        <td>
                          <span className="pl-sr">
                            {(payload.pageNo - 1) * payload.pageCount + i + 1}
                          </span>
                        </td>

                        {/* Product */}
                        <td>
                          <div className="pl-prod-cell">
                         <img src={getImageUrl(v?.productHeroImage)} alt="" className="pl-prod-img" />
                            <div className="pl-prod-name">{v?.name}</div>
                          </div>
                        </td>

                        {/* Category */}
                        <td>
                          <span className="pl-cat-chip">
                            {Array.isArray(v?.categoryId)
                              ? v.categoryId.map((cat) => cat.name).join(", ")
                              : v?.categoryId?.name || "—"}
                          </span>
                        </td>

                        {/* Price */}
                        <td>
                          <div className="pl-price-main">
                            Rs {v?.discountedPrice || v?.price || "—"}
                          </div>
                          {v?.discountedPrice && v?.price && (
                            <div className="pl-price-strike">Rs {v?.price}</div>
                          )}
                        </td>

                        {/* Stock */}
                        <td className="center">
                          <span className="pl-stock">{v?.stockQuantity ?? "—"}</span>
                        </td>

                        {/* Status */}
                        <td className="center">
                          {v?.status ? (
                            <span
                              className="pl-badge active"
                              onClick={() => setEditFormData({ name: v?.name, productHeroImage: v?.productHeroImage, status: true, _id: v?._id })}
                            >
                              <i className="ti ti-circle-check" style={{ fontSize: 13 }} /> Active
                            </span>
                          ) : (
                            <span
                              className="pl-badge inactive"
                              onClick={() => setEditFormData({ name: v?.name, productHeroImage: v?.productHeroImage, status: false, _id: v?._id })}
                            >
                              <i className="ti ti-circle-x" style={{ fontSize: 13 }} /> Inactive
                            </span>
                          )}
                        </td>

                        {/* Action */}
                        <td className="center">
                          <button
                            className="pl-view-btn"
                            onClick={() => navigate(`/product-details/${v?._id}`)}
                          >
                            <i className="ti ti-eye" /> View
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* ── Pagination ── */}
            <div className="pl-pagination">
              <div className="pl-show-row">
                Show
                <select
                  className="pl-select"
                  style={{ height: "34px", padding: "0 10px", minWidth: "unset" }}
                  value={payload.pageCount}
                  onChange={(e) => setPayload({ ...payload, pageCount: parseInt(e.target.value), pageNo: 1 })}
                >
                  {[10, 25, 50, 100].map((v) => (
                    <option key={v} value={v}>{v}</option>
                  ))}
                </select>
                entries
              </div>

              <div className="pl-page-btns">
                <button className="pl-pg-btn" disabled={payload.pageNo === 1} onClick={() => handlePageChange(payload.pageNo - 1)}>
                  <i className="ti ti-chevron-left" style={{ fontSize: 14 }} />
                </button>
                {[...Array(totalPages)].map((_, i) => {
                  const page = i + 1;
                  if (page === 1 || page === totalPages || (page >= payload.pageNo - 1 && page <= payload.pageNo + 1)) {
                    return (
                      <button key={page} className={`pl-pg-btn ${payload.pageNo === page ? "active" : ""}`} onClick={() => handlePageChange(page)}>
                        {page}
                      </button>
                    );
                  } else if ((page === payload.pageNo - 2 && page > 2) || (page === payload.pageNo + 2 && page < totalPages - 1)) {
                    return <button key={page} className="pl-pg-btn" disabled>…</button>;
                  }
                  return null;
                })}
                <button className="pl-pg-btn" disabled={payload.pageNo === totalPages} onClick={() => handlePageChange(payload.pageNo + 1)}>
                  <i className="ti ti-chevron-right" style={{ fontSize: 14 }} />
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* ── Edit Status Modal ── */}
      {editFormData?._id && (
        <div className="pl-modal-overlay" onClick={() => setEditFormData({ name: "", productHeroImage: "", status: "", _id: "" })}>
          <div className="pl-modal" onClick={(e) => e.stopPropagation()}>
            <div className="pl-modal-header">
              <div className="pl-modal-title">Update Product Status</div>
              <button className="pl-modal-close" onClick={() => setEditFormData({ name: "", productHeroImage: "", status: "", _id: "" })}>
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="pl-modal-body">
            <img src={getImageUrl(editFormData?.productHeroImage)} alt="" className="pl-preview-img" />
              <label className="pl-field-label">Product Name</label>
              <input className="pl-field-input" readOnly value={editFormData?.name} />
              <label className="pl-field-label">Status</label>
              <select
                className="pl-field-input"
                style={{ cursor: "pointer" }}
                value={editFormData?.status}
                onChange={(e) => setEditFormData({ ...editFormData, status: e.target.value })}
              >
                <option value="">Select Status</option>
                <option value={true}>Active</option>
                <option value={false}>Inactive</option>
              </select>
            </div>
            <div className="pl-modal-footer">
              <button
                className="pl-btn"
                style={{ background: "#f0eded", color: "#555" }}
                onClick={() => setEditFormData({ name: "", productHeroImage: "", status: "", _id: "" })}
              >
                Cancel
              </button>
              <button
                className="pl-btn pl-btn-red"
                disabled={!editFormData?.status || isLoading}
                style={{ opacity: !editFormData?.status ? 0.5 : 1 }}
                onClick={!isLoading ? updateProductFunc : undefined}
              >
                {isLoading ? "Saving…" : "Update Status"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Bulk Upload Modal ── */}
      {showBulkModal && (
        <div className="pl-modal-overlay" onClick={() => setShowBulkModal(false)}>
          <div className="pl-modal" onClick={(e) => e.stopPropagation()}>
            <div className="pl-modal-header">
              <div className="pl-modal-title">Bulk Upload Products</div>
              <button className="pl-modal-close" onClick={() => setShowBulkModal(false)}>
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="pl-modal-body">
              <label className="pl-field-label">Bulk Name</label>
              <input
                className="pl-field-input"
                type="text"
                placeholder="Enter a name for this upload batch"
                value={bulkForm.name}
                onChange={(e) => setBulkForm({ ...bulkForm, name: e.target.value })}
              />
              <label className="pl-field-label">Upload File (CSV / Excel)</label>
              <input
                className="pl-field-input"
                type="file"
                style={{ height: "auto", padding: "10px 14px" }}
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                onChange={(e) => setBulkForm({ ...bulkForm, file: e.target.files[0] })}
              />

              <label className="pl-field-label" style={{ marginTop: 4 }}>
  Product Images{" "}
  {/* <span style={{ color: "#bbb", fontWeight: 500, textTransform: "none" }}>
    (Excel ke productHeroImage/productGallery column me jo filenames diye hain, unhi files ko yahan select karo)
  </span> */}
</label>
<input
  className="pl-field-input"
  type="file"
  multiple
  accept="image/*"
  style={{ height: "auto", padding: "10px 14px" }}
  onChange={(e) =>
    setBulkForm({ ...bulkForm, images: Array.from(e.target.files) })
  }
/>
{bulkForm.images.length > 0 && (
  <div style={{ fontSize: 13, color: "#888", marginTop: -8, marginBottom: 14 }}>
    {bulkForm.images.length} image(s) selected
  </div>
)}

            </div>
            <div className="pl-modal-footer">
              <button className="pl-btn" style={{ background: "#f0eded", color: "#555" }} onClick={() => setShowBulkModal(false)}>
                Cancel
              </button>
              <button
                className="pl-btn pl-btn-red"
                disabled={isUploading || !bulkForm.name || !bulkForm.file}
                style={{ opacity: !bulkForm.name || !bulkForm.file ? 0.5 : 1 }}
                onClick={handleBulkUpload}
              >
                {isUploading ? (
                  <><span className="spinner-border spinner-border-sm me-1" /> Uploading…</>
                ) : (
                  <><i className="ti ti-upload" /> Upload</>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ProductList;